import { Check } from "lucide-react";
import { STEPS, getRegistrationSteps } from "@/lib/constants";
import { motion } from "framer-motion";

export const Stepper = ({ current, skipPolicies = false }) => {
  const steps = getRegistrationSteps(skipPolicies);
  const currentIdx = Math.max(0, steps.findIndex((s) => s.id === current));

  return (
    <nav
      className="w-full max-w-3xl mx-auto"
      aria-label="Registration progress"
      data-testid="registration-stepper"
    >
      <ol className="flex items-center justify-between relative">
        {/* Background line */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-[#E5E7EB] -z-0" />
        {/* Progress line */}
        <motion.div
          className="absolute top-4 left-0 h-0.5 bg-[#B60F2A] z-0"
          initial={{ width: 0 }}
          animate={{
            width: steps.length <= 1 ? "0%" : `${(currentIdx / (steps.length - 1)) * 100}%`,
          }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
        {steps.map((s, idx) => {
          const done = currentIdx > idx;
          const active = currentIdx === idx;
          return (
            <li
              key={s.id}
              className="flex flex-col items-center gap-2 relative z-10"
              data-testid={`stepper-step-${s.id}`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${
                  done
                    ? "bg-[#B60F2A] text-white"
                    : active
                    ? "bg-[#B60F2A] text-white ring-4 ring-[#FBE7EA]"
                    : "bg-white text-[#9CA3AF] border border-[#E5E7EB]"
                }`}
              >
                {done ? <Check className="h-4 w-4" /> : idx + 1}
              </div>
              <span
                className={`text-[11px] sm:text-xs font-medium tracking-wide text-center ${
                  active || done ? "text-[#111]" : "text-[#9CA3AF]"
                }`}
              >
                {s.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

/** Re-export for callers that still import STEPS from Stepper. */
export { STEPS };
